export default "__VITE_ASSET__jcBquIsT__"